<div class="months-period">
	<mat-form-field
		class="month-period-select no-label"
		hideRequiredMarker
		subscriptSizing="dynamic"
	>
		<mat-select
			[(value)]="selectedChoice"
			(selectionChange)="selectedChoiceChange($event)"
		>
			@for (choice of choices; track choice) {
				<mat-option [value]="choice.value">
					{{ choice.label | translate }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
</div>
